import React, { useEffect, useState } from "react";
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import { StyledForm } from "../../styled-components/StyledForm.style";

export const ModalExportar = ({
    isOpen,
    setIsOpen,
    onExportar 
}) => {
    const [isLoading, setisLoading] = useState(false);
    
    // --- ESPAÇO PARA FUTUROS PARÂMETROS ---
    // Exemplo:
    // const [formato, setFormato] = useState('XLSX');
    // const [comentarios, setComentarios] = useState(false);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const onAfterOpen = () => { };
    const closeModal = () => { 
        setisLoading(false);
        setIsOpen(false); 
    }

    const onClickAction = () => {
        Swal.fire({
            html: `Deseja Exportar o Relatório?`, 
            icon: "info",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            if (result.isConfirmed) {
                setisLoading(true);
                Swal.showLoading();
                
                try {
                    // --- COLETA DE PARÂMETROS FUTUROS ---
                    const parametrosDoModal = {
                        // Formato: formato,
                        // IncluirComentarios: comentarios
                        // Adicione aqui qualquer dado que o usuário preencher neste modal
                    };
                    
                    await onExportar(parametrosDoModal);

                    setisLoading(false);
                    setIsOpen(false);
                    Swal.close(); 
                    
                } catch (err) {
                    console.error(err); 
                    setisLoading(false);
                }
            } else {
                setisLoading(false);
            }
        });
    };

    useEffect(() => {
        if(isOpen) {}
    }, [isOpen])

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Exportar"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="28" height="28" className="me-2">
                                            <path fill={'#999'} d="M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7 256 32zM64 320c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-46.9 0-56.6 56.6c-31.2 31.2-81.9 31.2-113.1 0L110.9 320 64 320zm304 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"/></svg>                                    
                                    Exportar</p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                
                {/* --- ESPAÇO PARA INPUTS FUTUROS --- */}
                {/* <div className="row"> 
                       <div className="col">
                           Seus inputs de configuração de exportação virão aqui 
                       </div>
                    </div> 
                */}

                { isLoading ? 
                (
                <div className="text-center">
                    <div className="text-items-center">
                        <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                        <div className="mt-2">
                            <strong style={{ color: "#EE4B21" }}>Gerando relatório, por favor aguarde...</strong>
                        </div>
                    </div>
                </div>
                ) : (
                    <>
                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                    <Flex>
                        <Flex.Item>
                            <div className="row align-items-center justify-content-center">
                                <div className="col text-center">
                                    <input 
                                            className='default-button-red' 
                                            value={'Exportar'} 
                                            type="button" 
                                            onClick={onClickAction.bind()}/>
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    </>
                )}
            </StyledForm>
        </Modal>
    );
};